<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19V5vUZ/tc-custom/9781473848740.jpg?1701347596417" alt="This image is the cover for the book Artillery of the Napoleonic Wars: Artillery in Siege, Fortress and Navy, 1792–1815"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Artillery of the Napoleonic Wars: Artillery in Siege, Fortress and Navy, 1792–1815
      </h1>
      <p class="bookDescription body article font2">
        <b>“Filled with statistical information on the guns, ammunition, and carriages, used by the armies . . . places the reader on the ground with the gunners.”—</b><b><i>The Napoleon Series</i></b><br/>  <br/> Napoleon was an artilleryman before he was an emperor. He understood the power and effectiveness of cannon and their ability to pulverize defenses, reduce fortresses and destroy attacks. In return, the guns won Napoleon battles. <br/><br/> This impressive study chronicles the story of the guns and men during the twenty-three years of almost continuous warfare from 1792–1815: from the battlefields of continental Europe to the almost primitive terrain of North America and of the seas, lakes and rivers that connected them. <br/><br/> Detailed technical information is accompanied by vivid descriptions which allow the reader to imagine what it must have been liked to maneuver and man the guns in a variety of situations—whether on the march or on the battlefield. Based on years of research into regulations of the period, eyewitness accounts of artillerymen and material culled from official reports, the scope and depth of material will satisfy the serious researcher, while the lively narrative will appeal to the casual reader.<br/>  <br/> “Kiley’s research is impeccable and deserves the highest praise. Moreover, he writes in so entertaining a manner that he informs and educates without effort . . . For the enthusiastic student of the attack and defense of fortified places this is an essential book of reference.”—Fortress Study Group
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin F. Kiley
      </h2>
      
      <p class="authorDescription body article">Kevin F. Kiley is a retired US Marine Corps artillery officer. He is a graduate of West Point and has a master’s degree in Military History from Norwich University. He lives in North Carolina with his wife, Daisy, and his son, Michael.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d5e4e78